import React, { useState } from 'react';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {Box} from "@material-ui/core";
import {Header} from "../../components/Header/Header";
import {Container} from "../../components/Container/Container";
import Menu from '@material-ui/core/Menu';
import {makeStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';

const useStyles = makeStyles(() => ({
    menu: {
        marginTop: '50px',
        padding: '0 5px',
        borderRadius:  '5px',
    },
    card: {
        minWidth: '160px',
        minHeight: '70px',
        padding: '5px',
        width: '160px',
        height: '70px'

    },
    menu2: {
        marginTop: '50px',
        padding: '0 5px',
        borderRadius:  '5px',
    },
    card2: {
        marginTop: '50px',
        minWidth: '300px',
        minHeight: '70px',
        padding: '5px',
        width: '300px',
        height: '400px'

    }
}))


export const LoginLayout = ({children}) => {

    const [openCard, setOpenCard] = useState(null);
    const [openInfo, setOpenInfo] = useState(null);

    const openCardContact = (event) => {
        setOpenCard(event.currentTarget);
    }

    const closeCardContact = () => {
        setOpenCard(null);
      };
    
    const openCardInfo = (event) => {
        setOpenInfo(event.currentTarget);
    }

    const closeCardInfo = () => {
        setOpenInfo(null);
      };
    
    const classes = useStyles()

    return <Box>
        <Header>
            <Grid xs container spacing={2} justifyContent={'flex-end'}>
                <Grid item>
                    <Button 
                        variant="outlined" 
                        color={'inherit'}
                        onClick={openCardContact}
                        >
                        Контакты
                    </Button>
                    <Menu
                        anchorEl={openCard}
                        keepMounted
                        open={Boolean(openCard)}
                        onClose={closeCardContact}
                        className={classes.menu}
                    >
                        <Card 
                            children=" г. Москва, Ленинский проспект 63/2, 2904 +7 (499) 940-0-140 доб. 128"
                            className={classes.card}
                        />
                    </Menu> 
                </Grid>
                <Grid item>
                    <Button 
                        variant="outlined" 
                        color={'inherit'}
                        onClick={openCardInfo}
                        >
                        Информация
                    </Button>
                    <Menu
                         anchorEl={openInfo}
                         keepMounted
                         open={Boolean(openInfo)}
                         onClose={closeCardInfo}
                         className={classes.card2}
                    >
                        Программа «Конструктор документов супервайзера» (КДС), 
                        предназначенная для повышения качества документов и принятия 
                        оперативных решений, фиксирующая нарушения. 
                        Оформление, сбор, обработка документов, фиксирующих нарушения в области 
                        технологической и промышленной безопасности, охраны труда и окружающей среды и 
                        любой другой отрасли с понятием заполнения анкеты с достоверной ссылкой на 
                        локальные и федеральные нормативные документы.
                    </Menu> 
                </Grid>
            </Grid>
        </Header>
        <Container component={'main'} maxWidth={'xs'}>
            {children}
        </Container>
    </Box>
}